import React, { useEffect, useState } from "react";
import ApiURL from "../controllers/Api";
import AdminLayout from "./AdminLayout";
import CompanyLayout from "./CompanyLayout";

export default function EmployeeList() {
  const isCompanyView = localStorage.getItem("userType") === "company";
  const Layout = isCompanyView ? CompanyLayout : AdminLayout;
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const loadEmployees = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${ApiURL}crm/admin/get_employees.php`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.success === false) {
          throw new Error(result.message || "Failed to load employees");
        }
        setEmployees(result?.data?.employees || result?.employees || []);
      } catch (error) {
        console.error("Error loading employees:", error);
      }
    };

    loadEmployees();
  }, []);

  return (
    <Layout
      title="Recruiters"
      description={
        isCompanyView
          ? "Your company recruiters available for resume assignment."
          : "Current recruiters available for resume assignment."
      }
    >
      <div className="rounded-lg border border-gray-200 bg-white overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Name</th>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Email</th>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Phone</th>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Role</th>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Personnel ID</th>
                <th className="px-3 py-3 text-left font-medium text-gray-600">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {employees.map((employee) => (
                <tr key={employee.id} className="hover:bg-gray-50">
                  <td className="px-3 py-3 font-medium text-slate-900">{employee.name}</td>
                  <td className="px-3 py-3 text-slate-600">{employee.email}</td>
                  <td className="px-3 py-3 text-slate-600">{employee.mobile || "-"}</td>
                  <td className="px-3 py-3 text-slate-600">{employee.role_name || "-"}</td>
                  <td className="px-3 py-3 text-slate-600">{employee.personnel_id || "-"}</td>
                  <td className="px-3 py-3">
                    <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${employee.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>
                      {employee.status}
                    </span>
                  </td>
                </tr>
              ))}
              {employees.length === 0 ? (
                <tr><td colSpan={6} className="px-3 py-8 text-center text-slate-500">No recruiters found.</td></tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
